<template>
  <k-editor-form v-if="channel">
    <template v-slot:left>
      <k-autocomplete
        :items="instances"
        v-model="instance"
        label="Instance"
        item-text="title"
        item-value="id"
        :hint="hint"
        :persistent-hint="true">
      </k-autocomplete>
    </template>
    <template v-slot:right>&nbsp</template>
    <template v-slot:right-buttons>
      <k-btn size="m" flat @click="reset">Reset</k-btn>
      <k-btn size="m" color="success" @click="save(false)">Save</k-btn>
      <k-btn size="m" color="success" @click="save(true)">Save and close</k-btn>
    </template>
  </k-editor-form>
</template>
<script>
import ChannelModel from '@/models/channel.js'
import InstanceModel from '@/models/instance.js'

export default {
  props: ['id'],
  data () {
    var ch = this.$cloudserver.channel("channels:"+this.id);
    return {
      ws_channel: ch,
      channel: this.convertChannel(ch.data),
      instance: _.get(ChannelModel.instance(_.cloneDeep(ch.data)), "id")
    }
  },
  watch: {
    "ws_channel.data": {
      handler(newVal, oldVal) {
        if(typeof(newVal) != "undefined") {
          this.channel = this.convertChannel(newVal, oldVal);
        }
      },
      deep: true
    },
    '$route' (to, from) {
      if(typeof(from.meta.edit) != "undefined" && to.name == from.meta.edit) {
        this.ws_channel = this.$cloudserver.channel("channels:"+this.id);
        this.ws_channel.join();
      }
    }
  },
  computed: {
    instances () {
      return _.filter(this.$store.state.instances, (instance) => { return instance.type == this.channel.type; });
    },
    hint() {
      var instance = InstanceModel.get_instance(this.instance);
      if(_.isEmpty(instance)) return "";
      if(instance.meta.channel == this.id) {
        return "";
      }
      var old_instance = _.find(this.instances, (instance) => { return instance.meta.channel == this.id; });
      if(!_.isEmpty(old_instance)) {
        return "This channel will be removed from the \""+old_instance.title+"\" instance";
      }
      return "";
    }
  },
  methods: {
    save (close) {
			var self = this;
      if (!this.id) return;

      var ws_channel = this.$cloudserver.channel("instances:"+this.instance);
      ws_channel.join();

      if (typeof(ws_channel) != "undefined") {

        var instance = _.cloneDeep(InstanceModel.get_instance(this.instance));
        if(!_.isEmpty(instance) && instance.meta.channel != this.id) {
          var old_instance = _.find(this.instances, (instance) => { return instance.meta.channel == this.id; });
          if(!_.isEmpty(old_instance) && !confirm("This channel will be removed from the \""+old_instance.title+"\" instance\nAre you sure?")) {
            return;
          }
        }

        instance.meta.channel = this.id;

				ws_channel.save({instance: instance})
					.then((msg) => {
						if (typeof(self.id) == "undefined") {
							self.$message.success("Instance was created!");
						} else {
							self.$message.success("Instance was updated!");
						}
            ws_channel.leave();
						if(close) {
              self.$root.close_bottom_sheet();
            } else if(typeof(self.id) == "undefined" && typeof(this.$route.meta.edit) != "undefined") {
              this.$router.push({name: this.$route.meta.edit, params: {id: msg.data.id}})
            }
					})
					.catch((msg) => {
						console.log(msg);
						if (typeof(self.id) == "undefined") {
							self.$message.warning("Unable to create instance!");
						} else {
							self.$message.warning("Unable to update instance!");
						}
            ws_channel.leave();
					});

      }
		},
    reset () {
      this.channel = this.convertChannel(this.ws_channel.data);
    },
    convertChannel (newVal, oldVal) {
      var channel = _.cloneDeep(newVal);
      if(typeof(oldVal) != "undefined") {
        //TODO: Tähän muuttuneen datan tarkistus ja ilmoitus
      }
      this.instance = _.get(ChannelModel.instance(channel), "id");
      if(typeof(channel) == "undefined" || _.isEmpty(channel)) return undefined;
      return channel;
    }
  }
}
</script>
